import './instrument'
import React from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import { Helmet } from 'react-helmet'
import { getFontStylesheetTags } from '@farewill/ui/theme/Farewill'

import history from 'startup/common/history'
import { configureCookies, getCookieConfig } from 'lib/storage/cookies/config'
import { configureStore } from 'store'

import App from './App'
import setTrackingCookie from './setTrackingCookie'
import { configureOnboarding } from './configureOnboarding'
import { storeReferralParameters } from './storeReferralParameters'
import { storeVoucherCode } from './storeVoucherCode'
import storeQueryParameters from './storeQueryParameters'

const initialState = window.INITIAL_STATE || {}
const trackingCookieDomain = initialState.config.TRACKING_COOKIE_DOMAIN

import '../common/ui/styles/main.styl'

// Cookies must be configured before the Redux store is created when client-side
// code reads cookie-backed values during startup.
configureCookies(window.INITIAL_STATE.config)

// Set up Redux (note: this API requires redux@>=3.1.0):
const store = configureStore(initialState)

/**
 * Expose history and store objects when run via Cypress.
 * history
 *   We use this as part of a `goToRoute` custom Cypress command that
 *   allows us to navigate to an route without performing a browser
 *   level page navigation.
 * store
 *   Used by a `dispatch` custom Cypress command that allows us to update data
 *   in the store. This allows us to update/mock feature flags and other config
 *   variables in our Cypress tests.
 */
if (window.Cypress) {
  window._history = history
  window._store = store
}

const container = document.getElementById('root')

const render = () => {
  const { CookieNames } = getCookieConfig()
  setTrackingCookie({
    cookieName: CookieNames.LAST_TOUCH_TRACKING,
    cookieDomain: trackingCookieDomain,
    sessionStorage: window.sessionStorage,
    location: history.location,
    referrer: document.referrer,
  })
  configureOnboarding(store)
  storeQueryParameters(store)
  storeReferralParameters(store)
  storeVoucherCode(store)

  ReactDOM.render(
    <React.StrictMode>
      <Helmet>{getFontStylesheetTags('/ui/')}</Helmet>
      {/* NOTE: We don't need to inject @farewill/ui's BaseStylesheet here as
          it's inserted as a global style inside InitialLayout, and those styles
          are not removed from the DOM when client rendering takes over */}
      <Provider store={store}>
        <App history={history} store={store} />
      </Provider>
    </React.StrictMode>,
    container
  )
}

render()

if (module.hot) {
  module.hot.accept('../common/startup/common/routes', () => {
    setTimeout(render)
  })
}
